import { SelectedPhotoData } from '@classifieds-sell/trademe-core-ui';

export enum PropertyAgentContactDetailsType {
    primary = 'Primary',
    secondary = 'Secondary'
}

export interface PropertyAgentContactDetailsData {
    name: string | null;
    mobile: string | null;
    landLine: string | null;
    email: string | null;
    brandingImageId: number | null;
    photoUrl: string | null;
    isPhotoRemovalDisabled: boolean | null;
}

export interface PropertyAgentContactChanges {
    type: PropertyAgentContactDetailsType;
    agentPhoto: SelectedPhotoData | null;
    isRemoved: boolean | false;
}
